import React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS } from '../../core/constants';
import HeroBlob from '../../components/HomePage/HeroBlob';
import HeroPhone from '../../components/HomePage/HeroPhone';
import { supportedLocales } from '../../translations/types';
import LayoutV2 from '../../components/LayoutV2';
import { LocalesUnion } from '../../types/interfaces';
import useTranslation from '../../hooks/useTranslation';
import HeroSteps from '../../components/HomePage/HeroSteps';
import Intro from '../../components/HomePage/Intro';
import Outro from '../../components/HomePage/Outro';
import ContactUs from '../../components/HomePage/ContactUs';

const Page = styled.div`
  font-family: Inter;
`;

const Separator = styled.div`
  height: 200px;

  @media ${BREAKPOINTS.md} {
    height: 100px;
  }
`;

interface CProps {
  locale: LocalesUnion;
}

const Landing: React.FC<CProps> = ({ locale }) => {
  const { t } = useTranslation(locale);

  return (
    <LayoutV2
      description={t('HOMEPAGE_SUBTITLE')}
      title={`Deevent | ${t('HOMEPAGE_SUBTITLE')}`}
      path={`/${locale}`}
      locale={locale}
    >
      <Page>
        <Intro locale={locale} />
        <HeroBlob locale={locale} />
        <Separator />
        <HeroSteps locale={locale} />
        <Separator />
        <HeroPhone locale={locale} />
        <Separator />
        <ContactUs locale={locale} />
        <Outro />
      </Page>
    </LayoutV2>
  );
};

export async function getStaticProps({ ...ctx }) {
  const { lang } = ctx.params;

  return {
    props: { locale: lang },
  };
}

export async function getStaticPaths() {
  const paths = supportedLocales.map((locale) => {
    return `/${locale}`;
  });

  return {
    paths,
    fallback: false,
  };
}

export default Landing;
